import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import {SubcontractorTestValue} from "../../../operator-subcontractors-add copy/index";

interface SubcontractorProps {
    actualInitialSubcontractorAddValue: SubcontractorTestValue;
    addressID: string;
    subcontractorID: string;
}


export const Subcontractor = ({
    actualInitialSubcontractorAddValue,
    addressID,
    subcontractorID,
}: SubcontractorProps) => {

    const dataValues = [
        {
            title: "Nazwa wykonawcy",
            value: `${actualInitialSubcontractorAddValue.nazwa_wykonawcy
                ? actualInitialSubcontractorAddValue.nazwa_wykonawcy
                : "-"}`,
        },
        {
            title: "Nip",
            value: `${actualInitialSubcontractorAddValue.nip
                ? actualInitialSubcontractorAddValue.nip
                : "-"}`,
        },
        {
            title: "Telefon",
            value: `${actualInitialSubcontractorAddValue.telefon
                ? actualInitialSubcontractorAddValue.telefon
                : "-"}`,
        },
        {
            title: "E-mail",
            value: `${actualInitialSubcontractorAddValue.email
                ? actualInitialSubcontractorAddValue.email
                : "-"}`,
        },
    ];
    const addressValues = [
        {
            title: "Kod pocztowy",
            value: `${actualInitialSubcontractorAddValue.kod_pocztowy
                ? actualInitialSubcontractorAddValue.kod_pocztowy
                : "-"}`,
        },
        {
            title: "Miejscowosc",
            value: `${actualInitialSubcontractorAddValue.miejscowosc
                ? actualInitialSubcontractorAddValue.miejscowosc
                : "-"}`,
        },
        {
            title: "Ulica",
            value: `${actualInitialSubcontractorAddValue.ulica
                ? actualInitialSubcontractorAddValue.ulica
                : "-"}`,
        },
        {
            title: "Numer budynku",
            value: `${actualInitialSubcontractorAddValue.numer_budynku
                ? actualInitialSubcontractorAddValue.numer_budynku
                : "-"}`,
        },
        {
            title: "Numer lokalu",
            value: `${actualInitialSubcontractorAddValue.numer_lokalu
                ? actualInitialSubcontractorAddValue.numer_lokalu
                : "-"}`,
        },
        {
            title: "Wojewodztwo",
            value: `${actualInitialSubcontractorAddValue.wojewodztwo
                ? actualInitialSubcontractorAddValue.wojewodztwo
                : "-"}`,
        },
        {
            title: "Kraj",
            value: `${actualInitialSubcontractorAddValue.kraj
                ? actualInitialSubcontractorAddValue.kraj
                : "-"}`,
        },
    ];

    return (
        <SingleWarehouseWrapper>
            <Data>
                {/* <Title>Magazyn dane</Title> */}
                {dataValues.map((item) =>
                    <ItemWraper key={item.title}>
                        <ItemLabel>{item.title}:</ItemLabel>
                        <ItemValue>{item.value ? item.value : ""}</ItemValue>
                    </ItemWraper>
                )}
            </Data>
            <Address>
                {/* <Title>Magazyn Adress</Title> */}
                {addressValues.map((item) =>
                    <ItemWraper key={item.title} >
                        <ItemLabel>{item.title}:</ItemLabel>
                        <ItemValue>{item.value}</ItemValue>
                    </ItemWraper>
                )}
            </Address>
        </SingleWarehouseWrapper>
    );
};
const SingleWarehouseWrapper = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
padding: 32px;
@media (max-width:800px){
    flex-direction: column;
}
`;
const Data = styled.div`
display: flex;
flex-direction: column;
width:50%;
align-items: stretch;
-webkit-box-align: stretch;
place-content: stretch space-between;

@media (max-width:800px){
    width:100%;
}
`;
const Address = styled.div`
display: flex;
flex-direction: column;
width:50%;
align-items:stretch;
align-items: stretch;
-webkit-box-align: stretch;
place-content: stretch space-between;
padding-left:23px; 

@media (max-width:800px){
    width:100%;
    padding-left:0px; 
    margin-top:16px;
}
`;
const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
marin-bottom: 16px;
`;
const ItemWraper = styled.div`
display: flex;
flex-direction: row;
padding:3px 0px;
@media (max-width:400px){
    flex-direction: column;
    padding:0px 0px;
}
`;
const ItemLabel = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
min-width: 150px;
`;
const ItemValue = styled.div`
font- family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-left:16px;
@media (max-width:400px){
    flex-direction: column;
    padding-left:16px;
}
`;